// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"454":"45873194","504":"56240aca"}[chunkId] + ".css";
};